export default {"src":"/_next/static/media/patio_or_balcony.c22c835a.svg","height":100,"width":100};